const keys = {
  faq: {
    title: 'Looking for more info?',
    description: 'Learn more about your policy or how YouSet works.',
    visitFaq: 'Visit our FAQ',
  },
};

export default keys;

export type TranslationKeys = typeof keys;
